<template>
  <div class="details">
    <!-- 顶部标题 -->
    <div class="top clearfix">
      <div class="fl">
        <img
          src="../../assets/images/ticons/pepolechannel_title_icon.png"
          alt=""
        />
        <span></span
        ><b style="font-weight: 500">沉睡用户唤醒计划（人群营销计划名称）</b>
        <span class="tip1">待开始</span>
        <span class="tip2">执行中</span>
        <span class="tip3">待开始</span>
      </div>
      <div class="fr">长期计划：2021/10/10-2021/11/10，每日通知时间：18:00</div>
    </div>
    <!-- 1 -->
    <el-card class="my_card" shadow="never">
      <div class="top clearfix">
        <div class="fl">
          <img src="../../assets/images/ticons/data_icon.png" alt="" />
          <span></span><b style="font-weight: 500">数据汇总</b
          ><span class="text">统计营销活动关键数据</span>
        </div>
      </div>
      <ul>
        <li>
          <p>
            <span class="blurBar"></span><span class="fz14">通知成功人数</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="计划收到推送的用户总数"
              placement="right"
            >
              <img
                style="
                  width: 16px;
                  transform: translate(0px, 2px);
                  margin-left: 5px;
                "
                src="../../assets/images/newIcon/tishi_icon.png"
                alt=""
              />
            </el-tooltip>
          </p>
          <p class="fz29">36,2414</p>
        </li>
        <li>
          <p>
            <span class="blurBar"></span><span class="fz14">访客数</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="通过推送内容进入访问系统的用户数量（跨天去重）"
              placement="right"
            >
              <img
                style="
                  width: 16px;
                  transform: translate(0px, 2px);
                  margin-left: 5px;
                "
                src="../../assets/images/newIcon/tishi_icon.png"
                alt=""
              />
            </el-tooltip>
          </p>
          <p class="fz29">36,2414</p>
        </li>
        <li>
          <p>
            <span class="blurBar"></span><span class="fz14">下单人数</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="通过计划进入系统后的创建订单用户总数，计划执行期间下单人数"
              placement="right"
            >
              <img
                style="
                  width: 16px;
                  transform: translate(0px, 2px);
                  margin-left: 5px;
                "
                src="../../assets/images/newIcon/tishi_icon.png"
                alt=""
              />
            </el-tooltip>
          </p>
          <p class="fz29">36,2414</p>
        </li>
      </ul>
      <ul>
        <li>
          <p>
            <span class="blurBar"></span><span class="fz14">支付人数</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="下单人数那部分，成功支付的人数"
              placement="right"
            >
              <img
                style="
                  width: 16px;
                  transform: translate(0px, 2px);
                  margin-left: 5px;
                "
                src="../../assets/images/newIcon/tishi_icon.png"
                alt=""
              />
            </el-tooltip>
          </p>
          <p class="fz29">36,2414</p>
        </li>
        <li>
          <p>
            <span class="blurBar"></span><span class="fz14">支付订单数</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="通过计划进入系统后，且支付的订单数量"
              placement="right"
            >
              <img
                style="
                  width: 16px;
                  transform: translate(0px, 2px);
                  margin-left: 5px;
                "
                src="../../assets/images/newIcon/tishi_icon.png"
                alt=""
              />
            </el-tooltip>
          </p>
          <p class="fz29">36,2414</p>
        </li>
        <li>
          <p>
            <span class="blurBar"></span><span class="fz14">支付金额</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="通过计划进入系统后，支付的订单金额合计"
              placement="right"
            >
              <img
                style="
                  width: 16px;
                  transform: translate(0px, 2px);
                  margin-left: 5px;
                "
                src="../../assets/images/newIcon/tishi_icon.png"
                alt=""
              />
            </el-tooltip>
          </p>
          <p class="fz29">36,2414</p>
        </li>
      </ul>
    </el-card>
    <!-- 2 -->
    <el-card class="my_card" shadow="never">
      <div class="top clearfix">
        <div class="fl">
          <img src="../../assets/images/ticons/data_zhuanhua_icon.png" alt="" />
          <span></span><b style="font-weight: 500">转化效果</b
          ><span class="text">营销转化核心节点数据统计</span>
        </div>
      </div>
      <div class="dashed">
        <div class="das1">
          <span>通知-支付 转化率 10.00%</span
          ><img src="../../assets/images/ticons/yingxiao_line_bg.png" alt="" />
        </div>
        <div class="das2">
          <span>通知-访客 转化率 10.00%</span
          ><img
            src="../../assets/images/ticons/yingxiao_middleline_bg.png"
            alt=""
          />
        </div>
        <div class="das3">
          <span>访客-支付 转化率 10.00%</span
          ><img
            src="../../assets/images/ticons/yingxiao_smallline_bg.png"
            alt=""
          />
        </div>
        <ul>
          <li>
            <div class="left">
              <div class="main">
                <img
                  src="../../assets/images/ticons/data_tongzhi_icon.png"
                  alt=""
                />
                <p>通知</p>
              </div>
            </div>
            <div class="right">
              <div>
                <p class="fz12">推送成功人数</p>
                <p class="fz22" style="margin-top: 10px">
                  19,359,329<span class="fz10">人</span>
                </p>
              </div>
            </div>
          </li>
          <li>
            <div class="left">
              <div class="main">
                <img
                  src="../../assets/images/ticons/data_use_icon.png"
                  alt=""
                />
                <p>访客</p>
              </div>
            </div>
            <div class="right">
              <div>
                <p class="fz12">访客人数</p>
                <p class="fz22" style="margin-top: 10px">
                  19,359,329<span class="fz10">人</span>
                </p>
              </div>
            </div>
          </li>
          <li>
            <div class="left">
              <div class="main">
                <img
                  src="../../assets/images/ticons/data_pay_icon.png"
                  alt=""
                />
                <p>支付</p>
              </div>
            </div>
            <div class="right">
              <div>
                <p class="fz12">支付人数</p>
                <p class="fz22" style="margin-top: 10px">
                  19,359,329<span class="fz10">人</span>
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-card>
    <!-- 3 -->
    <el-card class="my_card" shadow="never">
      <div class="top clearfix">
        <div class="fl">
          <img
            src="../../assets/images/ticons/icon_xueshenghuaxiang_geren_gerenqingkuang_shetuanhuodongqingkuang.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">活动完成情况</b
          ><span class="text">营销活动每日关键数据统计</span>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        border
        :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
        class="my_table1"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column prop="d1" label="日期"> </el-table-column>
        <el-table-column prop="d2" label="目标完成率"> </el-table-column>
        <el-table-column prop="d3" label="受众人群"> </el-table-column>
        <el-table-column prop="d4" label="计划触发（人数）"> </el-table-column>
        <el-table-column prop="d5" label="发送成功"> </el-table-column>
        <el-table-column prop="d6" label="目标完成"> </el-table-column>
        <el-table-column prop="d7" label="发送失败"> </el-table-column>
        <el-table-column prop="d8" label="用户拒收"> </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        background
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="  prev, pager, next,sizes, jumper"
        :total="100"
      >
      </el-pagination>
    </el-card>
    <!-- 4 -->
    <el-card class="my_card" shadow="never">
      <div class="top clearfix">
        <div class="fl">
          <img
            src="../../assets/images/ticons/activeanalysis_retaind_icon.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">活动用户后续留存</b>
        </div>
      </div>
      <p class="endp">
        2021-06-16～2021-06-22过去7天参与活动的用户后续留存情况
      </p>
      <!-- 表格 -->
      <div class="tableBox">
        <div class="wenzi">
          在xxx时间有xxx用户参与活动，但有xxx客户连续x天未登录
        </div>
        <el-table
          border
          :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
          class="my_table1"
          :data="tableData2"
          style="width: 100%"
        >
          <el-table-column prop="d1" label="总体" width="155">
          </el-table-column>
          <el-table-column prop="d2" label="总人数"> </el-table-column>
          <el-table-column prop="d3" label="第1天">
            <template slot-scope="scope">
              <span
                :class="{
                  cellStyle: scope.row.m1 === 0 ? '' : true,
                }"
              >
                <span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n1
                }}</span
                ><span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n2
                }}</span>
                <span v-else>
                  {{ scope.row.d3 }}
                </span></span
              >
            </template>
          </el-table-column>
          <el-table-column prop="d4" label="第2天">
            <template slot-scope="scope">
              <span
                :class="{
                  cellStyle: scope.row.d4 === 0 ? '' : true,
                }"
              >
                <span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n1
                }}</span
                ><span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n2
                }}</span>
                <span v-else>
                  {{ scope.row.d3 }}
                </span></span
              >
            </template>
          </el-table-column>
          <el-table-column prop="d5" label="第3天">
            <template slot-scope="scope">
              <span
                :class="{
                  cellStyle: scope.row.d5 === 0 ? '' : true,
                }"
              >
                <span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n1
                }}</span
                ><span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n2
                }}</span>
                <span v-else>
                  {{ scope.row.d3 }}
                </span></span
              >
            </template>
          </el-table-column>
          <el-table-column prop="d6" label="第4天">
            <template slot-scope="scope">
              <span
                :class="{
                  cellStyle: scope.row.d6 === 0 ? '' : true,
                }"
              >
                <span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n1
                }}</span
                ><span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n2
                }}</span>
                <span v-else>
                  {{ scope.row.d3 }}
                </span></span
              >
            </template>
          </el-table-column>
          <el-table-column prop="d7" label="第5天">
            <template slot-scope="scope">
              <span
                :class="{
                  cellStyle: scope.row.d7 === 0 ? '' : true,
                }"
              >
                <span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n1
                }}</span
                ><span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n2
                }}</span>
                <span v-else>
                  {{ scope.row.d3 }}
                </span></span
              >
            </template>
          </el-table-column>
          <el-table-column prop="d8" label="第6天">
            <template slot-scope="scope">
              <span
                :class="{
                  cellStyle: scope.row.d8 === 0 ? '' : true,
                }"
              >
                <span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n1
                }}</span
                ><span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n2
                }}</span>
                <span v-else>
                  {{ scope.row.d3 }}
                </span></span
              >
            </template>
          </el-table-column>
          <el-table-column prop="d9" label="第7天">
            <template slot-scope="scope">
              <span
                :class="{
                  cellStyle: scope.row.d9 === 0 ? '' : true,
                }"
              >
                <span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n1
                }}</span
                ><span v-if="typeof scope.row.d3 == 'object'">{{
                  scope.row.d3.n2
                }}</span>
                <span v-else>
                  {{ scope.row.d3 }}
                </span></span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination
        background
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="  prev, pager, next,sizes, jumper"
        :total="100"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          d1: "2018.03.05",
          d2: "7.99%",
          d3: "沉睡客户",
          d4: "100",
          d5: "10",
          d6: "100",
          d7: "10",
          d8: "100",
        },
        {
          d1: "2018.03.05",
          d2: "7.99%",
          d3: "沉睡客户",
          d4: "100",
          d5: "10",
          d6: "100",
          d7: "10",
          d8: "100",
        },
        {
          d1: "2018.03.05",
          d2: "7.99%",
          d3: "沉睡客户",
          d4: "100",
          d5: "10",
          d6: "100",
          d7: "10",
          d8: "100",
        },
        {
          d1: "2018.03.05",
          d2: "7.99%",
          d3: "沉睡客户",
          d4: "100",
          d5: "10",
          d6: "100",
          d7: "10",
          d8: "100",
        },
        {
          d1: "2018.03.05",
          d2: "7.99%",
          d3: "沉睡客户",
          d4: "100",
          d5: "10",
          d6: "100",
          d7: "10",
          d8: "100",
        },
        {
          d1: "2018.03.05",
          d2: "7.99%",
          d3: "沉睡客户",
          d4: "100",
          d5: "10",
          d6: "100",
          d7: "10",
          d8: "100",
        },
      ],
      tableData2: [
        {
          d1: "2018.03.05",
          d2: "309人",
          d3: "97.07%",
          d4: "97.07%",
          d5: "97.07%",
          d6: "97.07%",
          d7: "97.07%",
          d8: "97.07%",
          d9: "97.07%",
        },
        {
          d1: "2018.03.06",
          d2: "309人",
          d3: { n1: "27人", n2: "96.73%" },
          d4: { n1: "27人", n2: "96.73%" },
          d5: { n1: "27人", n2: "96.73%" },
          d6: { n1: "27人", n2: "96.73%" },
          d7: { n1: "27人", n2: "96.73%" },
          d8: { n1: "27人", n2: "96.73%" },
          d9: { n1: "27人", n2: "96.73%" },
        },
        {
          d1: "2018.03.07",
          d2: "309人",
          d3: { n1: "27人", n2: "96.73%" },
          d4: { n1: "27人", n2: "96.73%" },
          d5: { n1: "27人", n2: "96.73%" },
          d6: { n1: "27人", n2: "96.73%" },
          d7: { n1: "27人", n2: "96.73%" },
          d8: { n1: "27人", n2: "96.73%" },
          d9: { n1: "27人", n2: "96.73%" },
        },
        {
          d1: "2018.03.08",
          d2: "309人",
          d3: { n1: "27人", n2: "96.73%" },
          d4: { n1: "27人", n2: "96.73%" },
          d5: { n1: "27人", n2: "96.73%" },
          d6: { n1: "27人", n2: "96.73%" },
          d7: { n1: "27人", n2: "96.73%" },
          d8: { n1: "27人", n2: "96.73%" },
          d9: { n1: "27人", n2: "96.73%" },
        },
        {
          d1: "2018.03.09",
          d2: "309人",
          d3: { n1: "27人", n2: "96.73%" },
          d4: { n1: "27人", n2: "96.73%" },
          d5: { n1: "27人", n2: "96.73%" },
          d6: { n1: "27人", n2: "96.73%" },
          d7: { n1: "27人", n2: "96.73%" },
          d8: { n1: "27人", n2: "96.73%" },
          d9: { n1: "27人", n2: "96.73%" },
        },
        {
          d1: "2018.03.10",
          d2: "309人",
          d3: { n1: "27人", n2: "96.73%" },
          d4: { n1: "27人", n2: "96.73%" },
          d5: { n1: "27人", n2: "96.73%" },
          d6: { n1: "27人", n2: "96.73%" },
          d7: { n1: "27人", n2: "96.73%" },
          d8: { n1: "27人", n2: "96.73%" },
          d9: { n1: "27人", n2: "96.73%" },
        },
      ],
    };
  },
};
</script>

<style lang="less">
.details {
  padding: 20px;
  .top {
    margin-top: 20px;
    .fl {
      float: left;
      font-size: 16px;
      display: flex;
      b {
        margin-left: 6px;
      }
      img {
        width: 20px;
        height: 20px;
      }
      .text {
        margin-left: 12px;
        color: #999999;
        font-size: 12px;
        line-height: 24px;
      }
      .tip1,
      .tip2,
      .tip3 {
        display: inline-block;
        width: 60px;
        height: 24px;
        background: rgba(194, 128, 255, 0.3);
        color: #a240fc;
        border-radius: 2px;
        margin-left: 5px;
        text-align: center;
        line-height: 24px;
        font-weight: 400;
        font-size: 14px;
      }
      .tip2 {
        background: rgba(250, 100, 0, 0.3);
        color: #fa6400;
      }
      .tip3 {
        background: rgba(109, 212, 0, 0.3);
        color: #468602;
      }
    }
    .fr {
      float: right;
      color: #999999;
      font-size: 12px;
    }
  }
  .my_card {
    margin-top: 20px;
    .top {
      margin-top: 0;
    }
    &:nth-child(2) {
      ul {
        margin-top: 20px;
        display: flex;
        li {
          margin-left: 300px;
          position: relative;
          &::after {
            position: absolute;
            top: 5px;
            right: -150px;
            content: "";
            width: 1px;
            height: 45px;
            background-color: #e6e6e6;
          }
          &:first-child {
            margin-left: 15px;
          }
          &:last-child::after {
            content: none;
          }
        }
      }
    }
    &:nth-child(3) {
      .dashed {
        position: relative;
        .das1,
        .das2,
        .das3 {
          position: absolute;
          display: flex;
          align-items: center;
          span {
            width: 55px;
            height: 42px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }
        .das1 {
          top: 13px;
          left: 138px;
        }
        .das2 {
          top: 44px;
          left: 200px;
        }
        .das3 {
          top: 165px;
          left: 201px;
        }
      }
      ul {
        margin-top: 30px;
        margin-left: 300px;
        li {
          display: flex;
          &:nth-child(1) {
            .left {
              .main {
                text-align: center;
                margin-left: 0;
                margin-top: -65px;
                img {
                  width: 22px;
                }
                p {
                  color: #fff;
                  font-size: 12px;
                  letter-spacing: 1px;
                }
              }
              border-top: 90px solid;
              border-top-color: #7898ff;
              border-left: 10px solid transparent;
              border-right: 10px solid #ebecfc;
              height: 0;
              width: 160px;
              border-radius: 0;
            }
            .right {
              margin-right: 100px;
              flex: 1;
              background-color: #ebecfc;
              position: relative;
              > div {
                position: absolute;
                top: 20px;
                right: 0;
                width: 200px;
                text-align: left;
              }
            }
          }
          &:nth-child(2) {
            margin-top: 5px;
            margin-left: 10px;
            .left {
              .main {
                text-align: center;
                margin-left: 0;
                margin-top: -65px;
                img {
                  width: 22px;
                }
                p {
                  color: #fff;
                  font-size: 12px;
                  letter-spacing: 1px;
                }
              }
              border-top: 90px solid;
              border-top-color: #61e6df;
              border-left: 10px solid transparent;
              border-right: 10px solid #f2f2f2;
              height: 0;
              width: 140px;
              border-radius: 0;
            }
            .right {
              margin-right: 100px;
              flex: 1;
              background-color: #f2f2f2;
              position: relative;
              > div {
                position: absolute;
                top: 20px;
                right: 0;
                width: 200px;
                text-align: left;
              }
            }
          }
          &:nth-child(3) {
            margin-top: 5px;
            margin-left: 20px;
            .left {
              .main {
                text-align: center;
                margin-left: 0;
                margin-top: -65px;
                img {
                  width: 22px;
                }
                p {
                  color: #fff;
                  font-size: 12px;
                  letter-spacing: 1px;
                }
              }
              border-top: 90px solid;
              border-top-color: #ff925f;
              border-left: 10px solid transparent;
              border-right: 10px solid #faf0ed;
              height: 0;
              width: 120px;
              border-radius: 0;
            }
            .right {
              margin-right: 100px;
              flex: 1;
              background-color: #faf0ed;
              position: relative;
              > div {
                position: absolute;
                top: 20px;
                right: 0;
                width: 200px;
                text-align: left;
              }
            }
          }
        }
      }
    }
    &:nth-child(4),
    &:nth-child(5) {
      //表格
      .el-table {
        border: 1px solid transparent;
      }
      .my_table1 {
        margin-top: 10px;
        .cell {
          text-align: center;
          font-size: 12px;
          padding-left: 0;
          padding-right: 0 !important;
        }
        .el-table__row {
          height: 65px;
        }
      }
      //分页
      .el-pagination {
        margin-top: 10px;
      }
      .el-pagination__jump {
        margin-left: 0;
      }
    }
    &:nth-child(5) {
      .tableBox {
        position: relative;
        .wenzi {
          z-index: 1;
          position: absolute;
          top: 171px;
          left: 204px;
          width: 137px;
          height: 71px;
          background: #ffffff;
          padding: 11px 5px 9px 12px;
          box-sizing: border-box;
          box-shadow: 0px 2px 11px 0px rgba(129, 129, 129, 0.5);
          border-radius: 4px;
          font-size: 12px;
        }
      }
      .el-table--mini td,
      .el-table--mini th {
        padding: 0px 0;
      }
      .endp {
        margin-top: 10px;
        font-size: 12px;
      }
      .my_table1 {
        margin-top: 20px;

        .cellStyle {
          display: inline-block;
         
          height: 65px;
          background-color: #90b5ff;
          text-align: center;
          color: #0013a5;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
  }
  //公共样式区
  .fz22 {
    font-size: 22px;
    font-weight: bold;
  }
  .fz29 {
    font-size: 29px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
  }
  .fz14 {
    font-size: 14px;
    color: #25313e;
    font-family: DINAlternate-Bold, DINAlternate;
  }
  .fz10 {
    font-size: 10px;
  }
  .blurBar {
    transform: translate(-5px, 0px);
    display: inline-block;
    width: 4px;
    height: 12px;
    background: #327eff;
    border-radius: 2px;
  }
}
</style>